export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    if ($('#sbi_images').length) {
      $('#sbi_images').addClass('zumix-carousel owl-carousel');
    }

    $('.owl-carousel li:nth-child(2)').addClass('big');
    $('.owl-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      items: 3,
      responsiveClass: true,
      dots: false,
      autoplay: false,
      responsive: {
        0:{
          items:2,
          nav:true,
          loop:true,
        },
        1120:{
          items:3,
        },
      },
    });

    $('.owl-carousel').on('changed.owl.carousel', function(event) {
      var index = event.item.index + 1;
      var index2 = index + 1;
      $('.owl-carousel .owl-item li').removeClass('big');
      $('.owl-carousel .owl-item:nth-child('+index2+') li').addClass('big');
    });


    // gtranslate button properties for english/spanish
    if (document.cookie.indexOf('googtrans=/en/es') !== -1) {
      $('.espanol .glink[title="Español"]').addClass('hidden');
    }
    else {
      $('.espanol .glink[title="English"]').addClass('hidden');
    }
    $('.espanol .glink').click(function () {
      $('.espanol .glink').removeClass('hidden');
      $(this).addClass('hidden');
    })

    // play radio button functionality
    if ($('#playradio').length && $('#zumixplayer').length) {
      $('#playradio').click(function () {
        var player = document.getElementById('player');
        if (document.cookie.indexOf('wp-playradio=true') !== -1) {
          document.cookie = 'wp-playradio=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
          $('#zumixplayer').removeClass('active');
          $('#playradio').removeClass('active');
          player.pause();
        }
        else {
          document.cookie = 'wp-playradio=true; path=/';
          $('#zumixplayer').addClass('active');
          $('#playradio').addClass('active');
          player.play();
          console.log(document.cookie)
        }
      });

      $(document).ready(function() {
        console.log(document.cookie.indexOf('wp-playradio=true'));
        var player = document.getElementById('player');
        if (document.cookie.indexOf('wp-playradio=true') !== -1) {
          $('#zumixplayer').addClass('active');
          $('#playradio').addClass('active');
          player.play();
        }
        else {
          player.pause();
        }
      })
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js